import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from '@nuxtjs/composition-api';

interface Props {
    reverse?: boolean,
    direction?: 'row' | 'column',
    loginIcon?: string,
    loginType?: 'tonal' | 'cta' | 'outline' | 'text',
    loginStyling?: 'primary' | 'secondary' | 'tertiary' | 'quaternary',
    loginSize?: 'l' | 'm' | 's' | 'xs',
    joinNowIcon?: string,
    joinNowType?: 'tonal' | 'cta' | 'outline' | 'text',
    joinNowStyling?: 'primary' | 'secondary' | 'tertiary' | 'quaternary',
    joinNowSize?: 'l' | 'm' | 's' | 'xs',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthButtons',
  props: {
    reverse: { type: Boolean, default: false },
    direction: { default: 'row' },
    loginIcon: null,
    loginType: { default: 'tonal' },
    loginStyling: { default: 'tertiary' },
    loginSize: null,
    joinNowIcon: null,
    joinNowType: { default: 'cta' },
    joinNowStyling: { default: 'primary' },
    joinNowSize: null
  },
  setup(__props: any) {

const props = __props as { reverse: boolean, direction: 'row' | 'column', loginIcon?: string, loginType: 'tonal' | 'cta' | 'outline' | 'text', loginStyling: 'primary' | 'secondary' | 'tertiary' | 'quaternary', loginSize?: 'l' | 'm' | 's' | 'xs', joinNowIcon?: string, joinNowType: 'tonal' | 'cta' | 'outline' | 'text', joinNowStyling: 'primary' | 'secondary' | 'tertiary' | 'quaternary', joinNowSize?: 'l' | 'm' | 's' | 'xs' };



const {
    reverse,
    loginIcon,
    loginType,
    loginStyling,
    loginSize,
    joinNowIcon,
    joinNowType,
    joinNowStyling,
    joinNowSize,
    direction,
} = toRefs(props);


return { __sfc: true,props, reverse, loginIcon, loginType, loginStyling, loginSize, joinNowIcon, joinNowType, joinNowStyling, joinNowSize, direction }
}

})